module.exports = __webpack_public_path__ + "static/media/genisis18.0a435117.jpg";